/**
 * Sample rates are defined as the inverse.
 * e.g. a sample rate of 100 = 1 in 100 events are sent.
 */
export const DEFAULT_SAMPLE_RATE = 100; // 1%
